import React, { useEffect } from 'react';

import { useCopyStore } from 'store';
import { isDesktop } from 'u9/utils/platform';

import * as NonFunctionalsStyles from './../NonFunctionals.styles';
import * as S from './UnsupportedBrowser.styles';

interface UnsupportedBrowserProps {
  setAccept(state: boolean): void;
}

const UnsupportedBrowserProps = ({ setAccept }: UnsupportedBrowserProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const copies = useCopyStore(state => state.copy);

  if (!copies.global) return null;
  const {
    global: {
      errors: { unsupportedBrowser: copy },
    },
  } = copies;

  let bodyCopy: string;
  if (isDesktop()) {
    bodyCopy = copy.body.desktop;
  } else {
    bodyCopy = copy.body.mobile;
  }

  return (
    <S.Wrapper>
      <NonFunctionalsStyles.Title>{copy.title}</NonFunctionalsStyles.Title>
      <br />
      <NonFunctionalsStyles.Description
        dangerouslySetInnerHTML={{ __html: bodyCopy }}
      />
      <br />
      <NonFunctionalsStyles.Button onClick={() => setAccept(true)}>
        {copy.cta}
      </NonFunctionalsStyles.Button>
    </S.Wrapper>
  );
};

export default UnsupportedBrowserProps;
